"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
}); //# sourceMappingURL=CustomErrorWithDataOptions.js.map
